import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:4000/api';

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: { 'Content-Type': 'application/json' },
});

api.interceptors.request.use((config) => {
  const token = sessionStorage.getItem('authToken');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export const wishlistAPI = {
  getWishlist: async () => {
    const response = await api.get('/wishlist');
    return response.data;
  },

  getWishlistIds: async () => {
    const response = await api.get('/wishlist/ids');
    return response.data;
  },

  toggleWishlist: async (propertyId) => {
    const response = await api.post('/wishlist/toggle', { propertyId });
    return response.data;
  },
};

export default wishlistAPI;
